export default {"src":"/_next/static/media/Facebook.26bad613.svg","height":37,"width":36,"blurWidth":0,"blurHeight":0};